import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Modal, InputGroup, FormControl, ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';
import SVG from "react-inlinesvg";
import { Formik, useFormikContext } from 'formik';
import BootstrapTable from 'react-bootstrap-table-next';
import { useIntl } from 'react-intl';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { useFilterObjectsUIContext } from '../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import * as uiHelpers from "../../../_metronic/layout/components/basePage/pages/ObjectsUIHelpers";
import { getHandlerTableChange, NoRecordsFoundMessage, PleaseWaitMessage, ShowToast, toAbsoluteUrl, ToastType } from '../../../_metronic/_helpers';
import { ModalProgressBar, Pagination } from "../../../_metronic/_partials/controls";
import * as actions from "../../../app/actions/generalActions";
import * as columnFormatters from "../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { sortCaret } from "../../../_metronic/_helpers";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";


export const initObject = {
    id: undefined,
    idNumber: "---",
    firstName: "---",
    lastName: "---",
    nationalCode: "---",
    // dormId: null,
    // dormTitle: "---",
    // blockId: null,
    // blockTitle: "---",
    // roomId: null,
    // roomTitle: "---",
    // collageId: null,
    // collageTitle: "---",
    // fieldId: null,
    // fieldTitle: "---",
    // gradeId: null,
    // gradeTitle: "---",
    // termId: null,
    // username: "---",
    // email: "---",
    // image: "",
    isActive: false,
};


const GolestanSearchDialog = ({ show, onHide, id, formListState, api, formResultState, methodName, localQuery, ...props }) => {

    // const [header, setHeader] = useState("ثبت پاسخ");

    const { currentState } = useSelector(
        (state) => ({ currentState: state.golestanUsers }),
        shallowEqual
    );

    const filterInitialValues = {
        searchText: "",
    }

    const [userObject, setUserObject] = useState(initObject);

    const intl = useIntl();
    const { entities, objectForEdit, actionsLoading } = currentState;

    const dispatch = useDispatch();

    useEffect(() => {
        if (objectForEdit && objectForEdit.idNumber)
            setUserObject({ ...objectForEdit })
        else
            setUserObject({ ...initObject })
    }, [objectForEdit]);

    const applyFilter = (values) => {
        const { searchText } = values;
        dispatch(actions.fetchObject("api/user", currentState.name, searchText, "SearchUserInGolestan"));
    };

    const okClicked = () => {
        if (userObject && userObject.idNumber && userObject.id) {
            // ShowToast(
            //     "امکان جایگزینی اطلاعات با دانشجویی که دارای کد دانشجویی متفاوت است وجود ندارد.",
            //     ToastType.error
            // );
        }
        else {
            var temp = {}
            //temp.id = id
            temp.idNumber = objectForEdit.idNumber
            temp.firstName = objectForEdit.firstName
            temp.lastName = objectForEdit.lastName
            temp.nationalCode = objectForEdit.nationalCode

            var ids = formResultState.entities.map((a) => a.id);

            //dispatch(actions.updateObjectLocal(userState.name, { ...userState.objectForEdit, ...temp }));
            dispatch(
                actions.updateSeatResultsFromUserObject(
                    api,
                    formResultState.name,
                    +id,
                    ids,
                    temp,
                    "UpdateSeatResultsFromUserObject"
                )
            ).then(() => {
                dispatch(actions.fetchObjectsById(api, formResultState.name, id, localQuery, methodName));
                onHide();
            });
        }

    };

    const cancelClicked = () => {
        dispatch(actions.fetchObjectsById(api, formResultState.name, id, localQuery, methodName));
        onHide();
    };


    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            // var object = { ...row }
            // parentSetFieldValue(field.name, object[fieldName])
            // // baseSetFieldValue(field.name, object[fieldName])
            // // applyFilter({ searchText: "" });
            // if (props.onChange) {
            //     props.onChange()
            // }
            // onHide()
        },
        // onMouseEnter: (e, row, rowIndex) => {
        //     console.log(`enter on row with index: ${rowIndex}`);
        // }
    }
    const selectRow = {
        mode: 'radio',
        clickToSelect: true,
        bgColor: '#b4dff0'
    };

    const getUserPic = () => {
        if (!userObject.image) {
            return "none";
        }

        return `url(${userObject.image})`;
    };

    return (
        <Modal
            // size="lg"
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            {actionsLoading && <ModalProgressBar />}
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    {"جستجوی کاربر در سیستم آموزشی گلستان"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {actionsLoading && <span>در حال جستجو ...</span>}

                {props.label && <label>{props.label}</label>}
                {/* <div className={getFieldCSSClasses(touched[field.name], errors[field.name])}>
                <div className="row align-items-center">
                    <div className="col-md-12 margin-bottom-10-mobile"> */}
                <Formik
                    initialValues={filterInitialValues}
                    onSubmit={(values) => {
                        applyFilter(values);
                    }}
                >
                    {({
                        values,
                        handleSubmit,
                        handleBlur,
                        handleChange,
                        setFieldValue,
                    }) => (
                        <div onSubmit={handleSubmit}>

                            <InputGroup className="bg-transparent mb-1">

                                <input
                                    type="number"
                                    className="form-control search-field-input"
                                    // className={getFieldCSSClasses(touched[field.name], errors[field.name])}
                                    // style={{ width: "100%" }}
                                    name="searchText"
                                    placeholder={"شماره دانشجویی را وارد کرده و آیکون جستجو را کلیک نمایید"}
                                    onBlur={handleBlur}
                                    value={values.searchText}
                                    // disabled={field.disabled}
                                    onChange={(e) => {
                                        setFieldValue("searchText", e.target.value);
                                    }}
                                />
                                {/* {errors[field.name] && touched[field.name] ? (
                                        <div className="invalid-datepicker-feedback">
                                            {errors[field.name].toString()}
                                        </div>
                                    ) : (
                                        <div className="feedback">
                                            {field.placeholder}
                                        </div>
                                    )} */}
                                {/* /> */}
                                <InputGroup.Append
                                    onClick={handleSubmit}
                                >
                                    <InputGroup.Text style={{ minWidth: "40px" }}>
                                        <span className="svg-icon svg-icon svg-icon-dark ">
                                            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                                            />
                                        </span>
                                    </InputGroup.Text>

                                </InputGroup.Append>
                            </InputGroup>

                        </div>
                    )}
                </Formik>


                {userObject &&
                    <div className=" d-flex flex-column align-items-center mt-10">

                        {/* <div className="form-group row ">
                            <div className="col-lg-6 col-xl-3">
                                <div
                                    className="image-input image-input-outline info"
                                    // id="kt_profile_avatar"
                                    style={{
                                        backgroundImage: `url(${toAbsoluteUrl(
                                            "/media/users/blank.png"
                                        )}`,
                                    }}
                                >
                                    <div
                                        className="image-input-wrapper"
                                        style={{ backgroundImage: `${getUserPic()}` }}
                                    />
                                </div>

                            </div>
                        </div> */}


                        <div className="list-timeline-item mb-3" key={1}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline align-right`}
                                    style={{ width: "120px", alignContent: "left" }}
                                >
                                    شماره دانشجویی  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.idNumber ? userObject.idNumber : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={2}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    نام  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.firstName ? userObject.firstName : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    نام خانوادگی  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.lastName ? userObject.lastName : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={4}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    کد ملی  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.nationalCode ? userObject.nationalCode : "---"}
                                </span>
                            </span>
                        </div>
                        {/* <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    مقطع تحصیلی  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.gradeTitle ? userObject.gradeTitle : "---"}
                                </span>
                            </span>
                        </div> */}
                        {/* <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    دانشکده  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.collageTitle ? userObject.collageTitle : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    رشته  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.fieldTitle ? userObject.fieldTitle : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    سرا  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.dormTitle ? userObject.dormTitle : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    بلوک/طبقه  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.blockTitle ? userObject.blockTitle : "---"}
                                </span>
                            </span>
                        </div>
                        <div className="list-timeline-item mb-3" key={3}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    اتاق  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.roomTitle ? userObject.roomTitle : "---"}
                                </span>
                            </span>
                        </div> */}
                        {/* <div className="list-timeline-item mb-3" key={4}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    ایمیل  :
                                </span>{" "}
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    {userObject.email ? userObject.email : "---"}
                                </span>
                            </span>
                        </div> */}
                        {/* <div className="list-timeline-item mb-3" key={5}>
                            <span className="list-timeline-text">
                                <span
                                    className={`label label-lg label-light-info label-inline`}
                                    style={{ width: "120px" }}
                                >
                                    وضعیت  :
                                </span>{" "}


                                {userObject.isActive && <span
                                    className={`label label-lg label-light-success label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    فعال
                                </span>}
                                {!userObject.isActive && <span
                                    className={`label label-lg label-light-danger label-inline`}
                                    style={{ width: "300px" }}
                                >
                                    غیرفعال
                                </span>}

                            </span>
                        </div> */}

                        {userObject && userObject.idNumber !== "---" &&
                            <div className="list-timeline-item mt-3">
                                با زدن دکمه تایید، اطلاعات کاربر جستجو شده در فرم تخت مورد نظر جایگزین می گردد
                            </div>}
                        {/* 
                    {userObject || userObject.idNumber !== "---" &&
                        <div className="list-timeline-item mt-3">
                            با زدن دکمه تایید، اطلاعات کاربر جستجو شده (به جز اطلاعاتی که در سامانه آموزشی ثبت نشده است ) در فرم کاربر جایگزین می گردد
                        </div>} */}
                    </div>

                }

            </Modal.Body>
            <Modal.Footer>
                {userObject && userObject.idNumber !== "---" &&
                    <div>
                        <button
                            type="button"
                            onClick={okClicked}
                            className="btn btn-success btn-elevate mr-2"
                        >
                            تایید
                        </button>

                        <button
                            type="button"
                            onClick={cancelClicked}
                            className="btn btn-light btn-elevate"
                        >
                            انصراف
                        </button>

                    </div>}
            </Modal.Footer>
        </Modal>
    );


}

export default GolestanSearchDialog
